const omit = function <T extends object, K extends keyof T>(target: T, ...keys: K[]): Omit<T, K> {
  const result = Object.fromEntries(
    (Object.entries(target) as [K, any][]).filter((x) => !keys.includes(x[0]))
  );

  return result as Omit<T, K>;
};

export default omit;
